package com.example.positionahead.domain

import com.example.positionahead.model.*

object PositionDetailAnalyzer {

    fun analyze(snapshot: PositionSnapshot, goal: FinancialGoal): PositionAnalysis {
        val symbol = snapshot.position.symbol.uppercase()
        val weight = snapshot.portfolioWeightPercent
        val targetWeight = goal.maxSinglePositionPercent // Simplification for now
        
        val reasonsToHold = mutableListOf<String>()
        val thingsToWatch = mutableListOf<String>()
        val sellTriggers = mutableListOf<String>()
        var signal = PositionSignal.HOLD

        // Reasons to Hold
        if (snapshot.unrealizedGainLossPercent > 10) reasonsToHold.add("Strong price performance")
        if (snapshot.position.assetClass == AssetClass.STOCK) reasonsToHold.add("Portfolio growth allocation")
        if ((snapshot.quote?.dividendYield ?: 0.0) > 2.0) reasonsToHold.add("Solid dividend yield")

        // Things to watch
        if (weight > targetWeight) {
            thingsToWatch.add("Position is ${(weight - targetWeight).toInt()}% above your preferred limit")
            signal = PositionSignal.WATCH
        }
        
        if (snapshot.unrealizedGainLossPercent < -10) {
            thingsToWatch.add("Significant unrealized loss")
            signal = PositionSignal.REVIEW
        }

        // Sell Case
        val sellCase = if (signal != PositionSignal.HOLD) {
            SellCase(
                portfolioReason = if (weight > targetWeight) "Target allocation: ${targetWeight}%; Current: ${weight.toInt()}%" else null,
                performanceReason = if (snapshot.unrealizedGainLossPercent < -15) "Down ${snapshot.unrealizedGainLossPercent.toInt()}% vs purchase" else null,
                fundamentalReason = if (snapshot.quote?.peRatio ?: 0.0 > 40.0) "Elevated P/E ratio" else null
            )
        } else null

        // Triggers
        sellTriggers.add("Falls below your fundamental threshold")
        sellTriggers.add("Position exceeds 15% of portfolio")
        sellTriggers.add("Better opportunity appears")

        return PositionAnalysis(
            symbol = symbol,
            signal = signal,
            reasonsToHold = reasonsToHold,
            thingsToWatch = thingsToWatch,
            sellTriggers = sellTriggers,
            sellCase = sellCase
        )
    }
}
